import { useCallback } from "react";
import type { PostingGateReason } from "@/hooks/usePostingGate";

/**
 * Verification prompt has been removed. Hook is preserved as a pass-through
 * so all existing call sites continue to compile and behave — actions run
 * immediately without any modal/prompt.
 */
export function useVerificationWarning() {
  const showWarningOrRun = useCallback((action: () => void) => {
    action();
  }, []);

  const noop = useCallback(() => {}, []);

  return {
    needsWarning: false,
    showWarningOrRun,
    modalProps: {
      open: false,
      onOpenChange: noop as (open: boolean) => void,
      onContinue: noop,
      reason: null as PostingGateReason,
    },
  };
}
